import React from 'react';
import PropTypes from 'prop-types';
import "./styles.css";

const PagePagination = ({ currentPage, totalPages, onPageChange, className }) => {
  const handlePageClick = (page) => {
    if (page >= 0 && page < totalPages) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(0, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(0, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageClick(i)}
          >
            {i + 1}
          </button>
        </li>
      );
    }

    return pageNumbers;
  };

  return (
    <nav className={`pagination-container ${className || ''}`}>
      <ul className="custom-pagination">
        <li className={`page-item ${currentPage === 0 ? "disabled" : ""}`}>
          <button
            className="page-link pagination-arrow"
            onClick={() => handlePageClick(currentPage - 1)}
            disabled={currentPage === 0}
          >
            <span>&laquo;</span>
          </button>
        </li>
        {renderPageNumbers()}
        <li
          className={`page-item ${
            currentPage === totalPages - 1 ? "disabled" : ""
          }`}
        >
          <button
            className="page-link pagination-arrow"
            onClick={() => handlePageClick(currentPage + 1)}
            disabled={currentPage === totalPages - 1}
          >
            <span>&raquo;</span>
          </button>
        </li>
      </ul>
    </nav>
  );
};

PagePagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default PagePagination;
